
import { api } from "./apiUser";

export const ApiAuth = api.injectEndpoints({
    reducerPath: "apiUser",
    endpoints: (build) => ({
        getCourse: build.query({
            query: ({ page, limit }) => `courses?page=${page}&limit=${limit}`,
            // Only have one cache entry because the arg always maps to one string
            serializeQueryArgs: ({ endpointName }) => {
                return endpointName
            },
            // Always merge incoming data to the cache entry
            merge(currentCacheData, responseData, _meta, args) {
                if (responseData.data.page === 1 && !currentCacheData.data.page) {
                    return responseData;
                }
                if (responseData.data.page > currentCacheData.data.page) {
                    currentCacheData.data.users.push(...responseData.data.users);
                    currentCacheData.data.page = responseData.data.page
                    return currentCacheData;
                }
                return currentCacheData
            },
            // Refetch when the page arg changes
            forceRefetch({ currentArg, previousArg }) {
                return currentArg !== previousArg
            },
            providesTags: ["courses"],
        }),
        getCourseId: build.query({
            query: (id) => `/courses/${id}`,
            providesTags: ["courses"],
        }),
        addCourse: build.mutation({
            query: (data) => ({
                url: '/consoltings',
                method: 'POST',
                body: data,
                formData: true,
                headers: {
                    'Content-type': 'application/json; charset=UTF-8',
                },
            }),
            invalidatesTags: ['consoltings'],
        }),
        editCourse: build.mutation({
            query: ({ formData, id }) => ({
                url: `/consoltings/${id}`,
                method: 'PATCH',
                body: formData,
                headers: {
                    'Content-type': 'application/json; charset=UTF-8',
                },
            }),
            invalidatesTags: ['consoltings'],
        }),
        deleteCourse: build.mutation({
            query: (id) => ({
                url: `/consoltings/${id}`,
                method: 'Delete',
                body: build,
                headers: {
                    'Content-type': 'application/json; charset=UTF-8',
                },
            }),
            invalidatesTags: ['consoltings'],
        }),
    }),
});


export const {
    useGetCourseQuery,
    useAddCourseMutation,
    useEditCourseMutation,
    useGetCourseIdQuery,
    useDeleteCourseMutation
} = ApiAuth;